import type { Gebied } from '@models/Gebied'

import { FilterSelectObject } from './FilterSelectObject'

type Props = {
  options: Gebied[]
  value: Gebied[] | null
  onFilterChange: ({ gebied }: { gebied: Gebied[] }) => void
  label?: string
}

export const FilterSelectGebied = ({
  label = 'Gebied',
  options,
  value,
  onFilterChange,
}: Props) => {
  return (
    <FilterSelectObject
      multiple
      label={label}
      options={options}
      filterKey="gebied"
      value={value}
      onFilterChange={({ gebied }) => onFilterChange({ gebied })}
      groupBy={(gebied) => (gebied.buitenGebied ? 'Anders' : 'Uw gebied')}
    />
  )
}
